import Vue from "vue";
import VueFire from "vuefire";
import VueRouter from "vue-router";
import Router from "./router";
import Vueresoure from "vue-resource";
import Vuelidate from "vuelidate";
import NProgress from "nprogress";
import App from "./App.vue";
import Vuex from "vuex";
import "../node_modules/nprogress/nprogress.css";
import infiniteScroll from "vue-infinite-scroll";
import { BootstrapVue, BootstrapVueIcons, CarouselPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";
import vueHeadful from "vue-headful";

Vue.component("vue-headful", vueHeadful);

// Install BootstrapVue
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(CarouselPlugin)
// Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin);
Vue.use(VueFire);
Vue.use(VueRouter);
Vue.use(Vueresoure);
Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.use(Vuex);

Vue.use(infiniteScroll);

Vue.filter("to-uppercase", function(value) {
  return value.toUpperCase();
});

// Vue.filter('snippet',function(value){
//   return value.slice(0,100) + '...';
// })
// const routes = [
//   {name:'Home', path:'/',component:mainPage },
//   {path:'/about-us',component:aboutUs },
//   {path:'/license',component:license },
//   {path:'/contact-us',component:contactUs },
//   {path:'/product/:id',component:product },
//   {path:'/brand/:id',component:brand }
// ];

const router = new VueRouter({
  mode: "history",
  routes: Router
});

// Vue.use(VuePageTitle, {
//   // prefix: 'My App - ',
//   router,
//   suffix: "- Thong Firearms ร้านปืนธง"
// });

Vue.filter("snippet", function(value) {
  var char = value.length;
  if (char <= 80) {
    return value;
  } else {
    return value.slice(0, 80) + "...";
  }
});

Vue.filter("to-uppercase", function(value) {
  return value.toUpperCase();
});

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start();
  }
  next();
});

router.afterEach(() => {
  NProgress.done();
});

new Vue({
  render: h => h(App),
  router
}).$mount("#app");

// import Vue from 'vue'
// import VueFire from 'vuefire'
// import VueRouter from 'vue-router'
// import App from './App.vue'
// import NProgress from 'nprogress';

// import mainPage from './component/mainpage.vue';
// import aboutUs from './component/aboutUs.vue';
// import license from './component/license.vue';
// import contactUs from './component/contactUs.vue';
// import product from './component/product.vue';
// import category from './component/category.vue';
// import brand from './component/brand.vue';

// import '../node_modules/nprogress/nprogress.css'

// Vue.use(VueFire)
// Vue.use(VueRouter)
// Vue.config.productionTip = false

// const routes = [
//   {path:'/',component:mainPage },
//   {path:'/about-us',component:aboutUs },
//   {path:'/license',component:license },
//   {path:'/contact-us',component:contactUs },
//   {path:'/product/:id',component:product },
//   {path:'/brand/:id',component:brand },
//   {path:'/category/:id',component:category }
// ];

// const router = new VueRouter({ mode: 'history', routes: routes });

// router.beforeResolve((to, from, next) => {
//   if (to.name) {
//       NProgress.start()
//   }
//   next()
// })

// router.afterEach(() => {
//   NProgress.done()
// })

// new Vue({
//   render: h => h(App),
//   router
// }).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js